import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";

import Page from "@/components/Page";
import Loading from "@/components/Loading";
import Breadcrumbs from "@/components/Breadcrumbs";
import MainActions from "@/components/MainActions";
import CardsContainer from "@/components/CardsContainer";
import CardsList from "@/components/CardsList";
import CardsTable from "@/components/CardsTable";
import VLFConfirmModal from "@/components/Modal/Confirm";

import {TeamAPI} from "@/api/team";

import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

import {SUCCESSFUL_OPERATION, ERROR_OPERATION} from "@/utils/constants";
import {fetchData} from "@/utils/functions";

import "./index.scss";

function SettingsTeamsPage(props) {
	const {handleNotification} = props;

	const navigate = useNavigate();

	const [loading, setLoading] = useState(false);
	const [teams, setTeams] = useState([]);

	const getTeams = async () => {
		setLoading(true);
		try {
			const response = await TeamAPI.list();
			setTeams(response);
		} catch (error) {
			handleNotification(ERROR_OPERATION, "error");
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		getTeams();
	}, []);

	const [id, setId] = useState();
	const [openHandleConfirm, setOpenHandleConfirm] = useState(false);

	const deleteTeam = () => {
		fetchData(
			() => TeamAPI.delete(id),
			undefined,
			() => setLoading(true),
			() => {
				setOpenHandleConfirm(false);
				getTeams();
				handleNotification(SUCCESSFUL_OPERATION, "success");
			},
			() => {
				handleNotification(ERROR_OPERATION, "error");
				setLoading(false);
			},
		);
	};

	const listConfiguration = {
		data: teams,
		title: (team) => team.name,
		actions: [
			{
				icon: <EditIcon />,
				variant: "outlined",
				title: "Modifica",
				onClick: (team) => navigate("/settings/teams/" + team.id + "/edit"),
			},
			{
				icon: <DeleteIcon />,
				variant: "outlined",
				title: "Elimina",
				onClick: (team) => {
					setId(team.id);
					setOpenHandleConfirm(true);
				},
				color: "error",
			},
		],
	};

	const columns = [{label: "Nome", key: "name", align: "start"}];

	const headerActions = [
		{
			icon: <AddIcon />,
			title: "Aggiungi",
			onClick: () => navigate("/settings/teams/new"),
		},
	];

	return (
		<Page>
			<Loading visible={loading} />
			<Breadcrumbs actions={<MainActions actions={headerActions} />} />
			<CardsContainer
				tableComponent={
					<CardsTable
						breadcrumbs
						configurationColumns={columns}
						data={teams}
						fullWidth
						rowActions
						handleEdit={(item) =>
							navigate("/settings/teams/" + item.id + "/edit")
						}
						handleDelete={(item) => {
							setId(item.id);
							setOpenHandleConfirm(true);
						}}
						defaultSortedField="name"
					/>
				}
				listComponent={
					<CardsList
						type="club"
						breadcrumbs
						listConfiguration={listConfiguration}
					/>
				}
			/>
			<VLFConfirmModal
				open={openHandleConfirm}
				confirm={deleteTeam}
				close={() => setOpenHandleConfirm(false)}
			/>
		</Page>
	);
}

export default SettingsTeamsPage;
